/**
 * Removes the Stripe checkout `session_id` from a URL. The checkout success
 * page carries it in the query string, and holding it is proof of purchase to
 * /api/billing/verify, so it must never reach analytics.
 */
export function scrubUrl(value: string): string {
	if (!value.includes("session_id=")) return value;
	try {
		const url = new URL(value);
		url.searchParams.delete("session_id");
		return url.toString();
	} catch {
		return value.replace(/([?&])session_id=[^&#]*&?/g, "$1").replace(/[?&]$/, "");
	}
}
